/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateTeamRequest,
  ErrorModel,
  GetTeamOutputBody,
  ListTeamsOutputBody,
  ReplaceTeamOutputBody,
  ReplaceTeamRequest,
} from '../models/index';
import {
    CreateTeamRequestFromJSON,
    CreateTeamRequestToJSON,
    ErrorModelFromJSON,
    ErrorModelToJSON,
    GetTeamOutputBodyFromJSON,
    GetTeamOutputBodyToJSON,
    ListTeamsOutputBodyFromJSON,
    ListTeamsOutputBodyToJSON,
    ReplaceTeamOutputBodyFromJSON,
    ReplaceTeamOutputBodyToJSON,
    ReplaceTeamRequestFromJSON,
    ReplaceTeamRequestToJSON,
} from '../models/index';

export interface CreateTeamOperationRequest {
    createTeamRequest: Omit<CreateTeamRequest, '$schema'>;
}

export interface GetTeamRequest {
    id: number;
}

export interface ListTeamsRequest {
    f?: string;
    p?: string;
    s?: string;
}

export interface ReplaceTeamOperationRequest {
    id: number;
    replaceTeamRequest: Omit<ReplaceTeamRequest, '$schema'>;
}

/**
 * 
 */
export class TeamsApi extends runtime.BaseAPI {

    /**
     * Creates request options for createTeam without sending the request
     */
    async createTeamRequestOpts(requestParameters: CreateTeamOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createTeamRequest'] == null) {
            throw new runtime.RequiredError(
                'createTeamRequest',
                'Required parameter "createTeamRequest" was null or undefined when calling createTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTeamRequestToJSON(requestParameters['createTeamRequest']),
        };
    }

    /**
     * Create team
     * Create Team
     */
    async createTeamRaw(requestParameters: CreateTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTeamOutputBody>> {
        const requestOptions = await this.createTeamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTeamOutputBodyFromJSON(jsonValue));
    }

    /**
     * Create team
     * Create Team
     */
    async createTeam(requestParameters: CreateTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTeamOutputBody> {
        const response = await this.createTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getTeam without sending the request
     */
    async getTeamRequestOpts(requestParameters: GetTeamRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/teams/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get team
     * Get Team
     */
    async getTeamRaw(requestParameters: GetTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTeamOutputBody>> {
        const requestOptions = await this.getTeamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTeamOutputBodyFromJSON(jsonValue));
    }

    /**
     * Get team
     * Get Team
     */
    async getTeam(requestParameters: GetTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTeamOutputBody> {
        const response = await this.getTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listTeams without sending the request
     */
    async listTeamsRequestOpts(requestParameters: ListTeamsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['f'] != null) {
            queryParameters['f'] = requestParameters['f'];
        }

        if (requestParameters['p'] != null) {
            queryParameters['p'] = requestParameters['p'];
        }

        if (requestParameters['s'] != null) {
            queryParameters['s'] = requestParameters['s'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/teams`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List teams
     * List Teams
     */
    async listTeamsRaw(requestParameters: ListTeamsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListTeamsOutputBody>> {
        const requestOptions = await this.listTeamsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListTeamsOutputBodyFromJSON(jsonValue));
    }

    /**
     * List teams
     * List Teams
     */
    async listTeams(requestParameters: ListTeamsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListTeamsOutputBody> {
        const response = await this.listTeamsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for replaceTeam without sending the request
     */
    async replaceTeamRequestOpts(requestParameters: ReplaceTeamOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling replaceTeam().'
            );
        }

        if (requestParameters['replaceTeamRequest'] == null) {
            throw new runtime.RequiredError(
                'replaceTeamRequest',
                'Required parameter "replaceTeamRequest" was null or undefined when calling replaceTeam().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/teams/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReplaceTeamRequestToJSON(requestParameters['replaceTeamRequest']),
        };
    }

    /**
     * Replace team
     * Replace Team
     */
    async replaceTeamRaw(requestParameters: ReplaceTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReplaceTeamOutputBody>> {
        const requestOptions = await this.replaceTeamRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReplaceTeamOutputBodyFromJSON(jsonValue));
    }

    /**
     * Replace team
     * Replace Team
     */
    async replaceTeam(requestParameters: ReplaceTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReplaceTeamOutputBody> {
        const response = await this.replaceTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
